import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {editEmployeeAttritionReady} from '../redux/employees'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'

import * as Helpers from '../../../common/helpers'


import {AttritionReasons} from './DropDowns/index'

//var TimePicker = require('basic-react-timepicker');


function filterUnwantedData(employeeAttritionData) {
    let data = {}
    if (employeeAttritionData && employeeAttritionData.data && employeeAttritionData.data) {
        data = employeeAttritionData.data
    }

    let newData = {}
            newData.id = data.id ? data.id : ""
            newData.name = data.employee.name ? data.employee.name : ""
            newData.email = data.employee.email ? data.employee.email : ""
            newData.code = data.employee.code ? data.employee.code : ""
            newData.mobile = data.employee.mobile ? data.employee.mobile : ""
            newData.manager_remarks = data.manager_remarks ? data.manager_remarks : ""
            newData.manager_reason_name = data.manager_reason.name ? data.manager_reason.name : ""

            newData.hr_reason_id = data.hr_reason_id ? data.hr_reason_id : ""
            newData.hr_remarks = data.hr_remarks ? data.hr_remarks : ""


            
            newData.city_name="NA"
            newData.work_location_type=data.employee.work_location_type ? data.employee.work_location_type : "NA"
            newData.work_location="NA"


            newData.created =data.created ? Helpers.getDateFormatForUTC(data.created) : "NA"

            if(data.employee.city && data.employee.city.name){
                newData.city_name=data.employee.city.name
            }


            if(data.employee.kitchen_work_location && data.employee.kitchen_work_location.name && data.employee.work_location_type==="Kitchen"){
                newData.work_location=data.employee.kitchen_work_location.name
            }

            if(data.employee.office_work_location_name && data.employee.office_work_location_name.name && data.employee.office_work_location_name!=="Kitchen"){
                newData.work_location=data.employee.office_work_location_name.name
            }
    
    return newData
}


class EditEmployeeAttrition extends Component {

    constructor() {
        super()
        this.state = {
            
            bodyHeight: "0px",
            clearIcon:null,
            lwd:new Date(),
                   
            employeeAttritionData:{},
            
            selectedEmployeeAttritionId: "",
            reasonId:"",
            remarks:"",

            remarksErrorText: false,
            remarksErrorData: '',       

            reasonIdErrorText: false,
            reasonIdErrorData: '',

            whatsAppGroupErrorText: false,
            whatsAppGroupErrorData: '',
           
         }


        this.whatsAppGroupComponent = null
        this.whatsAppGroupSection = null

        this.reasonIdComponent = null
        this.reasonIdSection = null       

        this.remarksComponent = null
        this.remarksSection = null
    
    
    
       
    }

    componentWillMount() {


        this.isComponentStillMounted = true
        this.props.dispatch(editEmployeeAttritionReady(false))
        
        if(this.props.employees && this.props.employees.employeesAttritionSelectedId && this.props.employees.employeesAttritionSelectedId !== null){
            this.setState({subTitle: Constants.EDIT_EMPLOYEE_ATTRITION})
            this.props.dispatch(headerDataUpdate(Constants.EDIT_EMPLOYEE_ATTRITION)) 
            this.props.dispatch(subHeaderDataUpdate())
            this.setState({
                selectedEmployeeAttritionId: this.props.employees.employeesAttritionSelectedId
            });
            this.getEmployeeAttritionById(this.props.employees.employeesAttritionSelectedId)
        }else{
            this.props.history.goBack()
        }
        
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
    }

    componentDidMount() {

        this.reasonIdSection = ReactDOM.findDOMNode(this.refs.reasonIdSection)        
        this.remarksSection = ReactDOM.findDOMNode(this.refs.remarksSection)

    }

    updateDimensions = () => {
        if (window.innerWidth <= 767) {
            this.setState({
                bodyHeight: (window.innerHeight - 130) + "px",
            })
        } else {
            this.setState({
                bodyHeight: (window.innerHeight - 100) + "px",
            })
        }
    }

    mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    whatsAppGroupChange= (data) => {
            this.whatsAppGroupComponent.value=data.value
            this.setState({
                whatsAppGroup :data.value,
                whatsAppGroupErrorText: false,
                whatsAppGroupErrorData: ''
            })
            this.whatsAppGroupSection.className= this.whatsAppGroupSection.className.replace(" has-error", "")
        }





getEmployeeAttritionById = (id) => {
    apiService.getEmployeeAttritionById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

            if (responseData && responseData.data) {
                let filterData=filterUnwantedData(responseData)
                   
                    this.setState({
                        employeeAttritionData: filterData,
                        reasonId:filterData.hr_reason_id,
                        remarks:filterData.hr_remarks,
                        })

                    this.remarksComponent.value=filterData.hr_remarks

                    
                     this.props.dispatch(editEmployeeAttritionReady(true))
            

                }else{
                    this.props.dispatch(editEmployeeAttritionReady(true))
                    this.props.history.goBack()
                }

            }else{

                 this.props.dispatch(editEmployeeAttritionReady(true))
                 this.props.history.goBack()
             }

        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(editEmployeeAttritionReady(true))
        })
}


    onSaveClick = () => {
        this.props.dispatch(editEmployeeAttritionReady(false))
        let data ={}


         let reasonIdObject = this.mandateValidation("reasonId", Constants.FORM_SELECT)
            if (reasonIdObject.status) {
                data.hr_reason_id = this.reasonIdComponent.value
            } else {
                this.props.dispatch(editEmployeeAttritionReady(true))
                return
            }

        let remarksObject = this.mandateValidation("remarks", Constants.FORM_INPUT)
            if (remarksObject.status) {
                data.hr_remarks = this.remarksComponent.value
            } else {
                this.props.dispatch(editEmployeeAttritionReady(true))
                return
            }

        let apiPayloadData=data


        apiService.editEmployeeAttrition(apiPayloadData,this.state.employeeAttritionData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(editEmployeeAttritionReady(true))
                        this.props.history.push("/dashboard/employeesAttrition/list")
                    } else {

                        this.props.dispatch(editEmployeeAttritionReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(editEmployeeAttritionReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })
            


    }

   
    onCancelClick = () => {
        this.props.history.goBack()
    }


    attritionReasonsChange= (data) => {
            this.reasonIdComponent.value=data.value
            this.setState({
                reasonId :data.value,
                reasonIdErrorText: false,
                reasonIdErrorData: ''
            })
            this.reasonIdSection.className= this.reasonIdSection.className.replace(" has-error", "")
        }

    
    render() {
        return (
            <div className="line-item-edit">

                 <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>


                <Dialog ref={el => this.dialog = el} />
                <section className="content">

                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>Add Attrition</h3>
                                </div>
                                <div className="form-horizontal">
                                        <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                            
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Name :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeAttritionData.name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Id :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeAttritionData.code}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Email Id :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeAttritionData.email}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Mobile :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeAttritionData.mobile}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeAttritionData.city_name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Work Location :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeAttritionData.work_location}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                             <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Manager Reason :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeAttritionData.manager_reason_name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Manager Remarks:</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeAttritionData.manager_remarks}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Attrition Date :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeAttritionData.created}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <hr/>
                                            </div>


                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                               <div className="col-md-6 col-sm-12 col-xs-12">
                                                  <div className="form-group" ref={el =>
                                                     this.reasonIdSection = el}>
                                                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason for Attrition *</label>
                                                     <div className="col-sm-9" ref={el =>
                                                                                     this.reasonIdComponent = el}>
                                                        <AttritionReasons type="HR_ATTRITION" attritionReasonsChange={this.attritionReasonsChange} selectedValue={this.state.reasonId} />
                                                        <span className="help-block" style={{ display: this.state.reasonIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                        {this.state.reasonIdErrorData}
                                                        </span>
                                                     </div>
                                                  </div>
                                               </div>
                                            </div>

                                             <div className="col-md-12 col-sm-12 col-xs-12">
                                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                                      <div className="form-group" ref={el =>
                                                         this.remarksSection = el}>
                                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks *</label>
                                                         <div className="col-sm-9">
                                                             <textarea className="form-control" placeholder="Enter Remarks...." ref={el => this.remarksComponent = el}
                                                                        onChange={(e) => {e.preventDefault() 
                                                                        this.keyedInputChange("remarks")}} />
                                                            <span className="help-block" style={{ display: this.state.remarksErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                            </span>
                                                         </div>
                                                      </div>
                                                   </div>

                                                 </div>



                                        </div>

                                        <div className="box-footer">
                                            <button
                                                className="btn btn-default"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.onCancelClick()
                                                }}>
                                                Cancel
                                            </button>
                                            <button
                                                className="btn btn-info pull-right"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.onSaveClick()
                                                }}>
                                                Save Changes
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </section>
            </div>
        )
    }



    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        employees: state.employees,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(EditEmployeeAttrition))


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/EditEmployeeAttrition.js